import styled from '@emotion/styled';

export const ModalHeaderFlag = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: ${({ theme }) => theme.color.grey100};
    border-radius: ${({ theme }) => theme.radius.main};
    font-size: 24px;
    flex-shrink: 0;
`;

export const ModalHeaderText = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const ModalTitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.large};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const ModalSubtitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[3]};

    & > i {
        font-size: 20px;
        color: ${({ theme }) => theme.color.black400};
    }
`;

export const SectionTitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const ProviderSectionTitle = styled.h3`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
    margin: 0 0 ${({ theme }) => theme.spacing[4]} 0;
`;

export const ProviderCardsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.spacing[3]};
`;

export const ProviderCard = styled.button<{ isSelected?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[4]};
    border: 2px solid ${({ theme, isSelected }) => (isSelected ? theme.color.bloodyMary : theme.color.grey200)};
    border-radius: ${({ theme }) => theme.radius.main};
    background: ${({ theme }) => theme.color.white100};
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s;

    &:hover {
        border-color: ${({ theme }) => theme.color.bloodyMary};
    }

    & > i {
        font-size: 24px;
        color: ${({ theme, isSelected }) => (isSelected ? theme.color.bloodyMary : theme.color.black200)};
    }
`;

export const ProviderCardTitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const ProviderCardDescription = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
`;

export const Divider = styled.hr`
    border: none;
    border-top: 1px solid ${({ theme }) => theme.color.grey200};
    margin: ${({ theme }) => theme.spacing[4]} 0;
`;

export const MiddlewareSection = styled.div`
    margin-top: ${({ theme }) => theme.spacing[2]};
`;

export const DeviceCard = styled.div`
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[3]};
    margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const DeviceCardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[3]};

    & > i {
        font-size: 18px;
        color: ${({ theme }) => theme.color.black300};
    }
`;

export const DeviceCardTitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const DeviceFieldsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.spacing[3]};
`;

export const BackButton = styled.button`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[1]};
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.color.black200};
    font-size: ${({ theme }) => theme.font.size.small};
    padding: 0;
    margin-bottom: ${({ theme }) => theme.spacing[3]};

    &:hover {
        color: ${({ theme }) => theme.color.black400};
    }

    & > i {
        font-size: 16px;
    }
`;
